import React from "react";
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from "../../../components/ui/card";
import { AdminLayout } from "../components";

export const ConfiguracionPage: React.FC = () => {
  return (
    <AdminLayout>
      <div className="space-y-6">
        {/* Header */}
        <div className="flex justify-between items-center">
          <div>
            <h1 className="text-3xl font-bold text-gray-900">
              Configuración del Sistema
            </h1>
            <p className="text-gray-600">
              Ajusta los parámetros y configuraciones de Fracto
            </p>
          </div>
        </div>

        {/* Contenido temporal */}
        <Card>
          <CardHeader>
            <CardTitle>Configuraciones</CardTitle>
          </CardHeader>
          <CardContent>
            <div className="text-center py-8">
              <p className="text-gray-500">Funcionalidad en desarrollo</p>
              <p className="text-sm text-gray-400 mt-2">
                Aquí se mostrarán las configuraciones del sistema
              </p>
            </div>
          </CardContent>
        </Card>
      </div>
    </AdminLayout>
  );
};
